import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable'
import { Box, Container, Paper, styled } from '@mui/material';
import userImage from "../../../../Assets/user_man_image.png"
import { batch, useDispatch, useSelector } from 'react-redux';
import actions from '../../../../ReduxStore/actions';
import { AlumniRegistratioConfirmAction } from '../../../../ReduxStore/Slices/Reports/RegistrationConformation/AlumniRegistratioConfirm';
import RejectCommendModal from '../../../../Components/RejectCommandModal/RejectCommendModal';
import { toast, ToastContainer } from 'react-toastify';
import FullPageLoader from '../../../../Components/FullPageLoader/FullPageLoader';


const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));
const RegistrationAlumniCofirmed = () => {
    const tableData = [
        { photo: userImage, firstName: 'Vallarasu', lastName: 'K', gender: "Male", batch: "2018-2022", yearOfCompletion: "2022", campus: "Chennai", course: "Apparel Marketing and Management", status: "Confirmed" },
        { photo: userImage, firstName: 'Pravin', lastName: 'K', gender: "Male", batch: "2018-2022", yearOfCompletion: "2022", campus: "Chennai", course: "BE", status: "Not Confirmed" },
        { photo: userImage, firstName: 'Vallarasu', lastName: 'K', gender: "Male", batch: "2018-2022", yearOfCompletion: "2022", campus: "Chennai", course: "BE", status: "confirmed" },
        { photo: userImage, firstName: 'Vallarasu', lastName: 'K', gender: "Male", batch: "2018-2022", yearOfCompletion: "2022", campus: "Chennai", course: "BE", status: "confirmed" },

    ];
    const tableHeadData = ['S.No', 'Photo', 'First Name', 'Last Name', 'Gender', 'Batch', 'Year of Completion', 'Campus', 'Course', "Status", "View"];

    const dispatch = useDispatch();

    const { AlumniRegistrationGetAll } = useSelector(state => state?.AlumniRegistrationGetAll);
    console.log(AlumniRegistrationGetAll, "AlumniRegistrationGetAll")
    const { AlumniRegistratioConfirm } = useSelector(
        (state) => state?.AlumniRegistratioConfirm
    );

    const { AlumniRegistrationReject } = useSelector(
        (state) => state?.AlumniRegistrationReject
    );

    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")
    const [rejectId, setRejectId] = useState(null)

    const [isRejectCommandModalOpen, setRejectCommandModalOpen] = useState(false)

    const handleRejectModalOpen = (id) => {
        setRejectCommandModalOpen(true)
        console.log(id, "idddddd")
        setRejectId(id)
    }

    const handleRejectModalClose = () => {
        setRejectCommandModalOpen(false)
    }

    // const handleRejectButtonClick = () => {

    // }

    const [loading, setLoading] = useState(false);


    const handleConFrimButton = async (id) => {
        setLoading(true)
        const data1 = {
            data: {},
            method: "patch",
            apiName: `approveUser/${id}`,
        };

        const responseData = await dispatch(actions.ALUMNIREGISTRATIONCONFIRM(data1));
        if (responseData?.payload?.message === "User approved successfully.") {
            setLoading(false)
            toast.success("User approved successfully.")
        } else {
            setLoading(false)
            toast.error(responseData?.payload?.message)
        }

    }

    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: `getAllUsers`,
            };

            const responseData = await dispatch(actions.ALUMNIREGISTRATIONGETALL(data1));
            console.log(responseData, "responseDataaa")
            // setResponseTableData(responseData?.payload)

        }


        fetchData();

    }, [AlumniRegistratioConfirm, AlumniRegistrationReject]);

    useEffect(() => {
        const tempArr = [];

        AlumniRegistrationGetAll?.data?.map((data, index) => {
            return tempArr.push({
                id: data?.user_id,
                photo: data?.profileImage,
                firstName: data?.first_name || '--',
                lastName: data?.last_name || '--',
                gender: data?.gender || '--',
                batch: data?.batch || '--',
                yearOfCompletion: data?.Year_of_completion || '--',
                campus: data?.campus || '--',

                course: data?.course || '--',
                status: data?.approval_status || '--',


            });
        });
        setRowTableData(tempArr);


    }, [AlumniRegistrationGetAll]);


    return (
        <div>
            {loading && <FullPageLoader />}

            <Box
                data-aos="zoom-in" data-aos-duration="1000"
                sx={{
                    position: 'relative',
                }}>
                <Box>
                    <ProfileContainer p={{ xs: 0 }} mb={2} >
                        <Container maxWidth="lg" >
                            <ResponsiveBox mt={2}>
                                <Paper elevation={3} sx={{ p: 3, flex: 1, width: { md: "100px" } }}>

                                    <CustomTable showViewMore={true} handleRejectModalOpen={handleRejectModalOpen} handleConFrimButton={handleConFrimButton} tableReportSearch={true} registrationConfirmed={true} tableData={rowTableData} tableHeadData={tableHeadData} title="Cygnusa Registration Confirmation" />
                                </Paper>
                            </ResponsiveBox>
                        </Container>
                    </ProfileContainer>
                </Box>
                
                {isRejectCommandModalOpen && (
                    <RejectCommendModal
                        // id={row.id}
                        id={rejectId}
                        open={isRejectCommandModalOpen}
                        onClose={handleRejectModalClose}
                    />
                )}
            </Box>

        </div>
    )
}

export default RegistrationAlumniCofirmed